import {
    SET_FOURNISSEURS_LOADING,
    SET_FOURNISSEURS_ERROR,
    FETCH_FOURNISSEURS_SUCCESS,
    FETCH_FOURNISSEURS_FAIL,
    CREATE_FOURNISSEUR_FAIL,
    UPDATE_FOURNISSEUR_FAIL,
    DELETE_FOURNISSEUR_SUCCESS,
    DELETE_FOURNISSEUR_FAIL,
} from "../actions/fournisseursActions";

const initialState = {
    loading: false,
    error: null,
    fournisseurs: [],
};

export default function fournisseursReducer(state = initialState, action) {
    switch (action.type) {
        case SET_FOURNISSEURS_LOADING:
            return { ...state, loading: action.payload };
        case SET_FOURNISSEURS_ERROR:
            return { ...state, error: action.payload };

        case FETCH_FOURNISSEURS_SUCCESS:
            return { ...state, fournisseurs: action.payload || [], error: null };

        case FETCH_FOURNISSEURS_FAIL:
        case CREATE_FOURNISSEUR_FAIL:
        case UPDATE_FOURNISSEUR_FAIL:
        case DELETE_FOURNISSEUR_FAIL:
            return { ...state, error: action.payload };

        case DELETE_FOURNISSEUR_SUCCESS:
            return { ...state, fournisseurs: state.fournisseurs.filter((x) => x.id !== action.payload), error: null };

        default:
            return state;
    }
}
